<template lang="pug">
<div class="u-loading">
  <div class="u-loading__symbol">
    <img src="@/assets/PMA_Logo.svg">
  </div>
</div>
</template>
<script>
export default {
  name: 'Loader'
}
</script>
<style lang="scss" scoped>
$secondaryColor: #fff;
$animationDuration: 3s;
$loadingSize: 128px;
$perspective: 250px;
.u-loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 99999;
  position: absolute;
  background-color: #fff;
  &__symbol {
    background-color: #fff;
    padding: 8px;
  animation: loading $animationDuration infinite;
  border-radius: 5px;
    img {
      display: block;
      max-width: 100%;
      animation: loading-icon $animationDuration infinite;
    }
  }
}

@keyframes loading {
  0% {
    transform: perspective($perspective) rotateX(0deg) rotateY(0deg);
  }
  15% {
    background-color: #fff;
  }
  16% {
    background-color: $secondaryColor;
  }
  50% {
    transform: perspective($perspective) rotateX(180deg) rotateY(0deg);
    background-color: $secondaryColor;
  }
  65% {
    background-color: $secondaryColor;
  }
  66% {
    background-color: #fff;
  }
  100% {
    transform: perspective($perspective) rotateX(180deg) rotateY(-180deg);
  }
}

@keyframes loading-icon {
  0% {
    transform: perspective($perspective) rotateX(0deg) rotateY(0deg);
  }
  15% {
    transform: perspective($perspective) rotateX(0deg) rotateY(0deg);
  }
  16% {
    transform: perspective($perspective) rotateX(180deg) rotateY(0deg);
  }
  50% {
    transform: perspective($perspective) rotateX(180deg) rotateY(0deg);
  }
  65% {
    transform: perspective($perspective) rotateX(180deg) rotateY(0deg);
  }
  66% {
    transform: perspective($perspective) rotateX(180deg) rotateY(180deg);
  }
  100% {
    transform: perspective($perspective) rotateX(180deg) rotateY(180deg);
  }
}

</style>
